module.exports = __webpack_public_path__ + "img/logo.f4afc84b.png";